import React, { useEffect, useState } from 'react';
const OFFER_MINUTES = 10;
const STORAGE_KEY = 'mma-offer-deadline';
function getDeadline(): number {
  if (typeof window === 'undefined') return Date.now() + OFFER_MINUTES * 60000;
  const stored = window.sessionStorage.getItem(STORAGE_KEY);
  if (stored) {
    const parsed = Number(stored);
    if (!Number.isNaN(parsed) && parsed > Date.now()) return parsed;
  }
  const deadline = Date.now() + OFFER_MINUTES * 60000;
  window.sessionStorage.setItem(STORAGE_KEY, String(deadline));
  return deadline;
}
function secondsRemaining(deadline: number) {
  return Math.max(0, Math.floor((deadline - Date.now()) / 1000));
}
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
type CountdownProps = {
  variant?: 'bar' | 'block';
};
export function Countdown({
  variant = 'block'
}: CountdownProps) {
  const [deadline] = useState(getDeadline);
  const [secondsLeft, setSecondsLeft] = useState(() => secondsRemaining(deadline));
  useEffect(() => {
    const id = window.setInterval(() => {
      setSecondsLeft(secondsRemaining(deadline));
    }, 1000);
    return () => window.clearInterval(id);
  }, [deadline]);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const label = `Quedan ${minutes} minutos y ${seconds} segundos`;
  if (variant === 'bar') {
    return <span className="font-mono text-sm font-bold tabular-nums" aria-label={label} data-id="element-16" data-mp="12sess1nr3j1r">
        {pad(minutes)}:{pad(seconds)}
      </span>;
  }
  return <div className="flex items-center justify-center gap-3" aria-label={label} data-id="element-17" data-mp="a3r2fro5a3hc">
      {[{
      value: pad(minutes),
      unit: 'min'
    }, {
      value: pad(seconds),
      unit: 'seg'
    }].map(item => <div key={item.unit} className="flex h-20 w-20 flex-col items-center justify-center rounded-2xl bg-ink text-cream" data-id="element-18" data-mp="k15j9sdzcua6">
          <span className="font-mono text-3xl font-black tabular-nums leading-none" data-id="element-19" data-mp="1zk0bpp6ivgge">
            {item.value}
          </span>
          <span className="mt-1 text-[10px] font-bold uppercase tracking-widest text-cream/60" data-id="element-20" data-mp="s5wt0f1v1hcl">
            {item.unit}
          </span>
        </div>)}
    </div>;
}